import {Pipe, PipeTransform} from '@angular/core';
import {WastageDto} from '../../../Models/Warehouse/Wastages/wastage.interface';

@Pipe({
  name: 'wastages',
  standalone: false
})
export class WastagesPipe implements PipeTransform {

  transform(items: WastageDto[], filter: { local?: number, type?: number }): WastageDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filter.local) {
      items = items.filter((item) => item.id_local === filter.local);
    }

    if (filter.type) {
      items = items.filter((item) => item.id_tipo === filter.type);
    }

    return items;

  }

}
